import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const Container = styled(Box)(({ theme }) => ({
  display         : 'flex',
  justifyContent  : 'space-between',
  alignItems      : 'center',
  backgroundColor : theme.palette.primary.blue1,
  height          : '3rem',
  padding         : '0 2rem',

  '& svg' : {
    color    : theme.palette.primary.white,
    cursor   : 'pointer',
    fontSize : '18px',
  },
}));
